import * as z from "zod";

export const getAiSettingsRequestStats = {
  name: "getAiSettingsRequestStats" as const,
  input: z.object({
    timeWindowDays: z.number().min(1).max(365).default(7),
    needsSetup: z
      .enum(["needs_setup", "no_setup", "all"])
      .default("needs_setup"),
  }),
  output: z.object({
    totalRequests: z.number(),
    uniqueTeams: z.number(),
    settingsStats: z.array(
      z.object({
        settingName: z.string(),
        totalCount: z.number(),
        uniqueTeamCount: z.number(),
        needsSetup: z.boolean(),
      }),
    ),
    timeRange: z.object({ startDate: z.date(), endDate: z.date() }),
  }),
};
